import React from "react";
import { MovementPatternType } from "@growth-machine-llc/stridist-api-client";
import { MovementPatternTypeLabels } from "../constants";
import { GenericLibraryContextFilter } from "../../filters/GenericLibraryContextFilter";

export function MovementPatternFilter({
  onChange,
  contextFilters,
  className,
}: {
  onChange?: (selected: MovementPatternType[]) => void;
  contextFilters?: MovementPatternType[];
  className?: string;
}) {
  return (
    <GenericLibraryContextFilter
      enumType={MovementPatternType}
      filterTypesLabels={MovementPatternTypeLabels}
      labelType="Movements"
      contextFilters={contextFilters}
      onChange={onChange}
      className={className}
    />
  );
}
